import React from 'react';
import { observer } from 'mobx-react';
import { analytics } from 'core/analytics';

import Icon from 'components/Icon';
import Tooltip from 'components/Tooltip';

import { routerStore } from 'core/routing';

import { UiPosition } from '../../config';

import { TabStyled, TabSectionRight } from './tab.styled';

export const ViewerTab = observer(() => {
  return (
    <TabStyled id='fileTab' tabHeight={UiPosition.top}>
      {
        <>
          <Tooltip delayShow={500} place='right' />
          <TabSectionRight
            onClick={() => {
              const newParams = Object.assign({}, routerStore.route.params);
              if (newParams.panel === 'discuss') delete newParams.panel;
              else newParams.panel = 'discuss';
              routerStore.navigate(routerStore.route.name, newParams, {
                replace: true,
              });

              analytics.sendEvent('viewer-chat-show');
            }}
            data-tip='Show Chat log'
          >
            <Icon name='chat_multiple' data-place='left' size='default' />
          </TabSectionRight>
        </>
      }
    </TabStyled>
  );
});
